import request from '@/utils/request';

const config = {
  state: {
    config: null,
    hasConfig: false,
  },
  mutations: {
    SET_CONFIG(state, result) {
      const st = state;
      st.config = result;
    },
    SET_HAS_CONFIG(state, result) {
      const st = state;
      st.hasConfig = result;
    },
  },
  actions: {
    setConfig({ commit }) {
      return request({
        url: `config.json?date=${new Date().getTime()}`,
        method: 'get',
      }).then((res) => {
        commit('SET_CONFIG', res.data);
        request.defaults.baseURL = res.data.BASE_URL + res.data.PROJECT_NAME;
        return res;
      });
    },
  },
};

export default config;
